<template>
    <div class="scc-drawing-list">
        <Drawing v-for="drawing in game.drawings" :key="drawing.id" :drawing="drawing" />
    </div>
</template>

<script>
export default {
    name: 'DrawingList',
    __editor: {
        requiredData: ['drawings'],
    },
    props: {
        game: {
            type: Object,
        },
    },
};
</script>

<style lang="scss">
@media screen and (min-width: 1024px) {
    .scc-drawing-list {
        max-width: 960px;
        margin: 0 auto;
    }
}
</style>
